import { useMemo } from 'react'

import { BaseTitle } from '@modals/layout'
import { PropsErrorBoundary } from '@shared/components/errors'
import useTranslation from 'next-translate/useTranslation'

import { ConfirmRemoveUserContent } from './ConfirmRemoveUser.Content'

import type { User } from '@shared/graphql'

export interface ConfirmRemoveUserProps {
  /**
   * User being removed.
   */
  user?: User
}

export const ConfirmRemoveUser: React.FC<ConfirmRemoveUserProps> = ({
  user: userProps,
}) => {
  const { t } = useTranslation('modals/settings/users')

  const [title, description, note] = useMemo<
    [string, string, string | undefined]
  >(() => {
    if (userProps?.id == null) {
      return [
        t('cancelInvite.title'),
        t('cancelInvite.description', { name: userProps?.name }),
        undefined,
      ]
    }

    return [
      t('removeUser.title'),
      t('removeUser.description', { name: userProps.name }),
      t('removeUser.note'),
    ]
  }, [t, userProps?.id, userProps?.name])

  return (
    <BaseTitle title={title} variant="center">
      <PropsErrorBoundary<Pick<ConfirmRemoveUserProps, 'user'>>
        props={{ user: userProps }}
        variant="page"
      >
        {({ user }) => (
          <ConfirmRemoveUserContent
            description={description}
            note={note}
            user={user}
          />
        )}
      </PropsErrorBoundary>
    </BaseTitle>
  )
}
